import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const hr = {
  backgroundColor: colors.GRAY_HR,
  height: '1px',
  border: '0px',
  marginBottom: '1.3rem',
  marginTop: '1.3rem',
};

export const mainContainer = {
  width: '85%',
  margin: '0 auto',
  fontFamily: 'metropolis',
};

export const fieldsContainer = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '3rem',
};

export const buttonsContainer = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
};

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: start;
  /* justify-content: space-around; */
`;

export const InputContainer = styled.label`
  width: 40vw;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  color: ${colors.GRAY_DARKER};
  font-family: metropolis;
`;

export const ImageUploadContainer = styled.div`
  width: 40vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${colors.GRAY_DARKER};
  font-family: metropolis;
`;

export const buttonStyle = (disabled = true) => ({
  width: '12%',
  fontWeight: 'bold',
  fontSize: '.8rem',
  marginTop: '1rem',
  marginBottom: '1.5rem',
  color: disabled ? colors.GRAY : colors.WHITE,
  background: disabled ? colors.GRAY_DARK : colors.GREEN,
  borderColor: colors.GREEN,
  marginLeft: disabled ? '0' : '1rem',
});

export const textInputStyle = {
  background: colors.WHITE,
  border: 'none',
  color: colors.BLACK,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
  fontSize: '1rem',
  fontFamily: 'metropolis',
};

export const dateInputStyle = {
  height: '7vh',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  fontFamily: 'metropolis',
  fontSize: '1rem',
  fontWeight: 'bold',
  borderRadius: '0.25rem',
  border: `0.01rem solid ${colors.GRAY}`,
};

export const redAsterix = {
  color: colors.RED,
  display: 'inline',
};

export default {
  hr,
  mainContainer,
  fieldsContainer,
  buttonsContainer,
  buttonStyle,
  InputContainer,
  ColumnContainer,
  textInputStyle,
  dateInputStyle,
  ImageUploadContainer,
  redAsterix,
};
